import { Box, Button, Center, Code, Collapse, Group, Stack, Text, Title } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import { IconAlertTriangle, IconCode } from '@tabler/icons-react'
import { Link } from '@tanstack/react-router'
import { getErrorMessage } from 'errors'

type Props = {
  error?: Error
}

export default function ErrorPage({ error }: Props) {
  const [opened, { toggle }] = useDisclosure(false)

  return (
    <Center h="100%" my="xl">
      <Stack align="center" gap="md">
        <IconAlertTriangle size={96} />
        <Title order={1}>Coś poszło nie tak</Title>
        <Text c="dimmed" ta="center" maw={360}>
          Wystąpił niespodziewany błąd. Spróbuj ponownie za chwilę lub wróć na stronę główną.
        </Text>
        <Box maw={400} mx="auto">
          <Group justify="center" mb={5}>
            <Button
              onClick={toggle}
              size="compact-sm"
              leftSection={<IconCode size={20} />}
              variant="light"
              color="gray"
            >
              Informacje dla dewelopera
            </Button>
          </Group>

          <Collapse in={opened}>
            <Text>
              <Code>{getErrorMessage(error)}</Code>
            </Text>
          </Collapse>
        </Box>
        <Button component={Link} to="/" size="md" radius="xl" mt="md">
          Wróć do strony głównej
        </Button>
      </Stack>
    </Center>
  )
}
